/**
 * F-108 chat limits (API 429 with `errors[0].code`, `errors[0].retryAt` and
 * Retry-After). The API's message already says when it frees; the app shows
 * it as it comes and keeps the action off until then.
 */
export interface ChatLimit {
  message: string | null
  code: string | null
  /** Epoch ms when the action frees; null when the API gives no time (e.g. limitPendingRequests). */
  until: number | null
}

export const chatLimitOf = (err: unknown): ChatLimit | null => {
  const e = err as { response?: { status?: number; data?: { message?: string; errors?: Array<{ code?: string; retryAt?: string; message?: string }> } }; retryAfter?: number }
  if (e?.response?.status !== 429) return null
  const first = e.response.data?.errors?.[0]
  const at = first?.retryAt ? Date.parse(first.retryAt) : NaN
  const until = Number.isFinite(at) ? at : e.retryAfter ? Date.now() + e.retryAfter * 1000 : null
  return { message: first?.message || e.response.data?.message || null, code: first?.code || null, until }
}

/** Schedules a callback when the limit frees (setTimeout caps at ~24.8 days). */
export const whenFree = (until: number | null, done: () => void): (() => void) => {
  if (!until) return () => {}
  const timer = window.setTimeout(done, Math.min(2_000_000_000, Math.max(0, until - Date.now())))
  return () => window.clearTimeout(timer)
}
